import React from "react";
import { useTranslation } from "react-i18next";
import DatePickerButton from "./DatePickerButton";

/**
 * DateTakenEditor — inline expand-in-place editor for the plant's "date
 * taken" field. Shows a date picker capped at today plus save/cancel/clear
 * buttons.
 *
 * Extracted from Result.jsx (iter62). Parent owns the draft state and the
 * async save handler; this component is purely presentational.
 */
export default function DateTakenEditor({
  hasSavedDate,
  dateDraft,
  onDateDraftChange,
  onCancel,
  onSave,
  onClear,
}) {
  const { t } = useTranslation();
  const today = new Date().toISOString().slice(0, 10);

  return (
    <div
      className="mt-3 bg-white border border-[#E8E5DF] rounded-2xl p-3"
      data-testid="date-taken-editor"
    >
      <label
        htmlFor="date-taken-input"
        className="block text-[11px] uppercase tracking-[0.14em] text-leaf-mist mb-1.5"
      >
        {t("result.dateTakenLabel")}
      </label>
      <DatePickerButton
        value={dateDraft}
        onChange={onDateDraftChange}
        max={today}
        testId="date-taken-input"
        ariaLabel={t("result.dateTakenLabel")}
        placeholder={t("result.dateTakenPlaceholder")}
        size="lg"
      />
      <p className="mt-1.5 text-[11px] text-leaf-mist">{t("result.dateTakenHelp")}</p>
      <div className="mt-2 flex gap-2 justify-end">
        {hasSavedDate && (
          <button
            type="button"
            onClick={onClear}
            data-testid="date-taken-clear"
            className="rounded-full px-3 py-1.5 text-xs text-rust hover:bg-parchment transition"
          >
            {t("result.dateTakenClearBtn")}
          </button>
        )}
        <button
          type="button"
          onClick={onCancel}
          data-testid="date-taken-cancel"
          className="rounded-full px-3 py-1.5 text-xs text-leaf-ink hover:bg-parchment transition"
        >
          {t("common.cancel")}
        </button>
        <button
          type="button"
          onClick={onSave}
          data-testid="date-taken-save"
          className="rounded-full px-3 py-1.5 text-xs bg-leaf text-white font-medium hover:bg-leaf-deep transition"
        >
          {t("common.save")}
        </button>
      </div>
    </div>
  );
}
